import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import piction from '../../utils/piction';
import UMOThumbnail from '../UMOThumbnail';

function UMOInsertThumbnails({ umoIDs, onThumbnailClick }) {
  const [umoMap, setUmoMap] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!umoIDs || umoIDs.length === 0) {
      setIsLoading(false);
      return;
    }

    piction
      .getUMOs(`UMO_IDS:"${umoIDs.join(',')}"`, { MAXROWS: umoIDs.length.toString() })
      .then((res) => {
        const map = {};
        if (res.umoList && res.umoList.all) {
          res.umoList.all.forEach((umo) => {
            map[umo.id] = umo;
          });
        }
        setUmoMap(map);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching UMO thumbnails:', err);
        setError(err);
        setIsLoading(false);
      });
  }, [umoIDs]);

  if (isLoading) {
    return (
      <div className="umo-insert-thumbnails umo-insert-thumbnails--loading">
        <span className="umo-insert-thumbnails__loader" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="umo-insert-thumbnails umo-insert-thumbnails--error">
        {umoIDs.map((id) => (
          <button
            key={id}
            type="button"
            className="umo-insert-thumbnails__fallback-btn"
            onClick={() => onThumbnailClick(id)}
          >
            {id}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="umo-insert-thumbnails">
      {umoIDs?.map((id) => {
        const umo = umoMap[id];

        return (
          <button
            key={id}
            type="button"
            className="umo-insert-thumbnails__item"
            onClick={() => onThumbnailClick(id)}
            title={`UMO ID: ${id}${umo?.name ? ` - ${umo.name}` : ''}`}
          >
            {umo ? (
              <UMOThumbnail umo={umo} noSensitiveOverlay />
            ) : (
              <span className="umo-insert-thumbnails__id">{id}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}

UMOInsertThumbnails.propTypes = {
  umoIDs: PropTypes.arrayOf(PropTypes.string).isRequired,
  onThumbnailClick: PropTypes.func.isRequired,
};

export default UMOInsertThumbnails;
